// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6863170f","977":"c73844b0"}[chunkId] + ".chunk.js";
};